import './styles.scss';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <img src="/assets/images/FastLimp-Img-Top-banner-1.jpg" alt="Logo" className="hero-logo" />
          <h1>Transforme seu espaço com nossos serviços de limpeza</h1>
          <p>
            Oferecemos soluções profissionais de limpeza para residências e empresas, 
            garantindo um ambiente <span className="highlight">impecável</span> e saudável.
          </p>
          <Link to="/catalog" className="cta-button">
            Conheça nossos serviços
          </Link>
          <p className="corporate-text">
            Serviços corporativos disponíveis sob demanda
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <h2>Nossos Serviços</h2>
        <p>Conheça nossa gama completa de serviços de limpeza</p>
        <div className="services-grid">
          <div className="service-card">
            <img src="/assets/images/product.svg" alt="Limpeza Residencial" />
            <h3>Limpeza Residencial</h3>
          </div>
          <div className="service-card">
            <img src="/assets/images/product.svg" alt="Limpeza Comercial" />
            <h3>Limpeza Comercial</h3>
          </div>
          <div className="service-card">
            <img src="/assets/images/product.svg" alt="Limpeza Predial" />
            <h3>Limpeza Predial</h3>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <h2>Sobre Nós</h2>
        <p>
          Somos especialistas em serviços de limpeza, com anos de experiência no mercado.
          Nossa equipe é treinada e qualificada para oferecer o melhor serviço aos nossos clientes.
        </p>
        <p>
          Comprometemo-nos com a excelência, utilizando produtos de qualidade e técnicas
          modernas para garantir a satisfação total dos nossos clientes.
        </p>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2>O que nossos clientes dizem</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"Serviço excelente! A equipe é muito profissional e atenciosa."</p>
            <h4>Maria Silva</h4>
          </div>
          <div className="testimonial-card">
            <p>"Melhor empresa de limpeza que já contratei. Super recomendo!"</p>
            <h4>João Santos</h4>
          </div>
          <div className="testimonial-card">
            <p>"Atendimento impecável e resultados surpreendentes."</p>
            <h4>Ana Oliveira</h4>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>Perguntas Frequentes</h2>
        <div className="faq-container">
          <div className="faq-item">
            <h3>Como funciona o agendamento?</h3>
            <p>
              Você pode agendar nossos serviços através do site ou por telefone.
              Nossa equipe entrará em contato para confirmar os detalhes.
            </p>
          </div>
          <div className="faq-item">
            <h3>Quais são as formas de pagamento?</h3>
            <p>
              Aceitamos cartões de crédito, débito, PIX e transferência bancária.
            </p>
          </div>
          <div className="faq-item">
            <h3>Vocês fornecem os produtos de limpeza?</h3>
            <p>
              Sim, utilizamos produtos profissionais de alta qualidade em todos os nossos serviços.
            </p>
                </div>
                </div>
        <div className="contact-cta">
          <a href="https://wa.me/5511999999999" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
            Fale conosco pelo WhatsApp
          </a>
                </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <img src="/assets/images/main-image.svg" alt="Logo" className="footer-logo" />
        <p>© 2024 Sua Empresa de Limpeza. Todos os direitos reservados.</p>
        <div className="footer-links">
          <Link to="/privacy">Política de Privacidade</Link>
          <Link to="/terms">Termos de Uso</Link>
        </div>
      </footer>
            </div>
  );
};

export default Landing;